export default __webpack_public_path__ + "static/enterprise-a6e2bcfcecfaa78b2feb16c7eff93a15.png";